import React from 'react';
import StatusColumn from 'src/common/utils/TableColumnIcons/StatusColumn';

export const StatusColumnFormat = (value) => {
	return (
		<>
			<StatusColumn
				value={value}
				color={value === 'Activo' ? 'primary' : 'black'}
				light
			/>
		</>
	);
};
